import React, { Component } from 'react';
import UploadIcon from 'react-icons/lib/md/file-upload';
import VideoIcon from 'react-icons/lib/md/video-library';
import FaArrowLeft from 'react-icons/lib/ti/arrow-left';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import { compose } from 'ramda';
import {
  fetchVideo,
  fetchCurrentUser,
  screenshot,
  uploadScreenshot,
} from 'src/actions';
import AnimatedLogo from 'src/assets/logo.gif';
import { withProviders } from 'src/common/hocs/with-providers';
import { selectAllMeState } from 'src/common/state/me/me-selectors';
import { selectAllVideosState } from 'src/dashboard/state/videos/videos-selectors';
import { getVideo, selectIsMobile } from 'src/misc/selectors';
import { getBestSourceUrl } from 'src/misc/utilities';
import ThumbnailSelectionControls from 'src/misc/videoEditor/ThumbnailSelectionControls';
import 'src/misc/videoEditor/videoEditor.css';

import './thumbnail.css';

const mapStateToProps = (state, ownProps) => {
  const videos = selectAllVideosState(state);
  return {
    me: selectAllMeState(state),
    video: getVideo(videos.cache, ownProps.shortcode),
    mobile: selectIsMobile(state),
  };
};

const hasCustomPoster = (video) => parseInt(video.thumbnail_offset || 0) === -1;

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    dispatch,
    fetchVideo: (version = ownProps.version) => {
      return dispatch(fetchVideo(ownProps.shortcode, version));
    },
    screenshot: (options) => {
      return dispatch(screenshot(ownProps.shortcode, options));
    },
    uploadScreenshot: (screenshot) => {
      return dispatch(uploadScreenshot(ownProps.shortcode, screenshot));
    },
    fetchCurrentUser: () => {
      return dispatch(fetchCurrentUser());
    },
  };
};

class Thumbnail extends Component {
  constructor() {
    super();
    this.state = {
      upload: null,
    };
    this.setState = this.setState.bind(this);
  }
  componentWillMount() {
    if (!this.props.video || !getBestSourceUrl(this.props.video)) {
      this.setState({ isFetching: true });

      this.props.fetchVideo().then(() => {
        this.setState({ isFetching: false });
      });
    }
  }

  onDone() {
    const self = this;
    this.setState({ working: true });
    let promise;
    if (this.state.upload) {
      promise = this.props.uploadScreenshot(this.state.upload);
    } else {
      promise = this.props.screenshot({
        thumbOffset: this.state.thumbOffset || this.getDefaultOffset(),
      });
    }
    promise
      .then((_) => {
        self.setState({ working: false });
        browserHistory.goBack();
      })
      .catch((e) => {
        self.setState({ working: false });
        alert(e.message);
      });
  }

  isCustom() {
    if (this.state.upload == null) {
      if (!this.props.video) {
        return false;
      }
      return hasCustomPoster(this.props.video);
    }
    return this.state.upload;
  }

  getDefaultOffset() {
    let defaultOffset = 0;
    if (this.props.video) {
      const currentOffset = parseInt(this.props.video.thumbnail_offset || 0);
      if (hasCustomPoster(this.props.video) || currentOffset === 0) {
        defaultOffset = this.props.video.duration / 2;
      } else {
        defaultOffset = currentOffset;
      }
    }
    return defaultOffset;
  }

  render() {
    let defaultOffset = this.getDefaultOffset();

    return (
      <div className="thumbnail-container">
        <a
          className="back"
          href="/"
          onClick={(e) => {
            e.preventDefault();
            browserHistory.goBack();
          }}
        >
          <FaArrowLeft />
        </a>
        <div className="thumbnail videoeditor">
          <form style={{ display: 'none' }}>
            <input
              id="upload-input"
              type="file"
              ref="fileInput"
              accept="image/*"
              onChange={() => {
                const files = this.refs.fileInput.files;
                this.setState({ upload: files[0] });
                this.refs.fileInput.value = '';
              }}
            />
          </form>
          {this.state.isFetching || !this.props.video ? (
            <div className="loading-indicator">
              <img src={AnimatedLogo} alt="presentation" />
            </div>
          ) : (
            <div ref="container">
              <div className="card">
                <div
                  className="clip-preview"
                  ref={(r) => {
                    if (r) {
                      this.previewPane = r;
                    }
                  }}
                >
                  {this.isCustom() ? (
                    <img
                      alt="Custom thumbnail"
                      style={{
                        width: '100%',
                        height: this.previewPane
                          ? this.previewPane.clientWidth *
                            (this.props.video.height / this.props.video.width)
                          : '100%',
                      }}
                      src={
                        this.state.upload
                          ? URL.createObjectURL(this.state.upload)
                          : this.props.video.thumbnail_url
                      }
                    />
                  ) : (
                    <video
                      onLoadedData={() => {
                        this.videoRef.currentTime =
                          this.state.thumbOffset || defaultOffset;
                      }}
                      src={getBestSourceUrl(this.props.video)}
                      ref={(r) => {
                        if (r) {
                          this.videoRef = r;
                        }
                      }}
                    />
                  )}
                </div>
              </div>
              <div className="card" id="clip-controls">
                {!this.isCustom() ? (
                  <ThumbnailSelectionControls
                    ref="clipControls"
                    thumbOffset={this.state.thumbOffset || defaultOffset}
                    duration={this.props.video.duration * 0.95}
                    onChange={(value) => {
                      this.videoRef.currentTime = value;
                      this.setState({
                        thumbOffset: value,
                      });
                    }}
                  />
                ) : (
                  ''
                )}
                <div id="clip-controls-footer">
                  {!this.props.mobile ? (
                    <button
                      id="upload"
                      className="clipper-tool clipper-tool-button"
                      onClick={(e) => {
                        e.preventDefault();
                        this.refs.fileInput.click();
                      }}
                    >
                      <span className="upload-icon">
                        <UploadIcon /> Upload Image
                      </span>
                    </button>
                  ) : (
                    ''
                  )}
                  {this.isCustom() ? (
                    <button
                      id="select"
                      className="clipper-tool clipper-tool-button"
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState({ upload: false });
                      }}
                    >
                      <span className="upload-icon">
                        <VideoIcon /> Use video frame
                      </span>
                    </button>
                  ) : (
                    ''
                  )}
                  <button
                    className="done-button blue-button"
                    disabled={this.state.working}
                    onClick={this.onDone.bind(this)}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProviders({ design: 'v1' })
)(Thumbnail);
